<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>ic_tap_icon_3</title>
    <g id="落地页" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g
        transform="translate(-374.000000, -798.000000)"
        fill="#60D390"
        fill-rule="nonzero"
        id="编组-5"
      >
        <g transform="translate(0.000000, 790.000000)">
          <g id="返利" transform="translate(363.000000, 0.000000)">
            <g id="ic_tap_icon_3" transform="translate(11.000000, 8.000000)">
              <path
                d="M12.000108,1 C3.64672696,1 1,3.64672694 1,12.0001081 C1,20.3532731 3.64672693,23 12.000108,23 C20.3534892,23 23,20.3532731 23,12.0001081 C23,3.64672697 20.3534891,1 12.000108,1 Z M8.54711567,15.2959916 C9.50932748,14.1659811 9.94881852,12.5555343 9.86558884,10.4619727 L9.86558884,5.56500526 L15.5785899,5.56500526 C16.8754425,5.56500526 17.9643165,5.41882712 18.8432986,5.12551421 L18.8432986,6.31847318 C18.0056443,6.5285564 16.9598201,6.63245002 15.7042954,6.63245002 L11.4350904,6.63245002 L11.4350904,8.64144266 L18.4038075,8.64144266 L18.4038075,9.70869608 C17.8592749,11.6342677 17.0225773,13.1205396 15.8925667,14.1659811 C16.7715488,14.8360279 17.7760452,15.4010332 18.9060557,15.8609969 L18.9060557,16.9282503 C17.0639051,16.3004879 15.7454319,15.6520616 14.9508275,14.9820147 C14.0718454,15.6520616 12.731943,16.3004879 10.9328423,16.9282503 L10.9328423,15.923754 C12.1041806,15.3803693 13.1086769,14.7937434 13.9463312,14.1657897 C12.9831627,13.1203482 12.2296948,11.8648235 11.6861188,10.3990242 L13.3183775,10.3990242 C13.6951114,11.445805 14.2386874,12.3875443 14.9506362,13.2242418 C15.7041041,12.4298287 16.3318664,11.2575337 16.8341146,9.70850474 L11.4350904,9.70850474 L11.4350904,10.27351 C11.6019325,13.2456711 10.6395293,15.3174208 8.54711567,16.4885679 L8.54711567,15.2959916 Z M7.16588538,5.00000001 C7.75155456,6.08887401 8.14895244,7.13450685 8.35865303,8.13900317 L6.78915143,8.13900317 C6.62135272,7.21888453 6.28690329,6.17229504 5.78465512,5.00000001 L7.16588538,5.00000001 L7.16588538,5.00000001 Z M19.2198412,18.6860232 L10.1166172,18.6860232 C8.73538697,18.7271597 7.79364775,18.3299531 7.29139961,17.4932555 C6.66363723,18.2467234 5.82598298,18.7489716 4.7801588,19 L4.7801588,18.0582608 C5.82598296,17.5982971 6.32823113,16.8654932 6.28690329,15.8609969 L6.28690329,10.5247298 L4.7801588,10.5247298 L4.7801588,9.45747633 L7.85640485,9.45747633 L7.85640485,15.4215058 C7.89773269,16.8448293 8.69310246,17.5778246 10.2421314,17.6187697 L19.2198412,17.6187697 L19.2198412,18.6860232 L19.2198412,18.6860232 Z"
                id="形状"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

export default defineComponent({
  name: 'YbSvgRebate',
  props: {
    colors: {
      type: Array as PropType<string[]>,
      default: () => {
        return []
      }
    },
    width: {
      type: String,
      default: '24'
    },
    height: {
      type: String,
      default: '24'
    }
  }
})
</script>
